import * as React from 'react';

import { EFeedbackScreen } from '../../types/redux';
import { Feedback as FeedbackComponent, Thanks } from '../../components/Feedback';
import { FeedbackFormContainer } from '../FeedbackFormContainer';

export interface IFeedbackProps {
  screen: EFeedbackScreen;
  isVisibleForm: boolean;
  setDimensionsFeedback(top: number, height: number): void;
}

export function Feedback({ screen, isVisibleForm, setDimensionsFeedback }: IFeedbackProps) {
  if (!isVisibleForm) {
    return null;
  }

  return screen === EFeedbackScreen.Form ? (
    <FeedbackComponent formContainer={<FeedbackFormContainer />} setDimensionsFeedback={setDimensionsFeedback} />
  ) : (
    <Thanks />
  );
}
